<template>
	<el-dialog title="提示" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false" :before-close="handleClose">
		<div class="content">
			<i class="el-icon-warning" style="line-height: 24px"></i>
			<div class="ml-6">
				<div class="fz-14" style="line-height: 24px">{{ content }}</div>
				<div class="fz-14 mt-8">
					<div class="font-bold">{{ drName }}</div>
					<div class="talent-wrap">
						<div class="talent-item" v-for="(item, index) in partners" :key="index">
							<yx-avatar :size="40" :src="item.avatar_url"></yx-avatar>
							<div class="info">
								<div class="ellipsis">{{ item.partner_role_name }}</div>
								<div class="yx-color-text-regular mt-4">{{ item.mobile }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<span slot="footer">
			<el-button @click="handleClose">{{ type != 1 ? '取 消' : '关 闭' }}</el-button>
			<el-button v-if="type != 1" type="primary" @click="submit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { drRoleType } from '@/utils/dataMap';
export default {
	name: 'hintDialog',
	data() {
		return {
			type: 0,
			msg: '',
			partners: [],
			team_institution_infos: [],
			dialogVisible: false,
			content: '',
			status: '',
			isDaren: true,
			statusMap: new Map([['选品','待选品'],['开播','已交付'],['待播','待交付'],['申样','待寄样']])
		};
	},
	computed: {
		drName() {
			return drRoleType.name;
		},
	},
	methods: {
		show(type, retail_type, status, partners, team_institution_infos) {
			this.type = type;
			this.status = this.statusMap.get(status);
			this.isDaren = retail_type === 0;
			this.partners = partners;
			this.team_institution_infos = team_institution_infos;
			this.tipsTextFun();
			this.dialogVisible = true;
		},
		tipsTextFun() {
			const { type, status, isDaren, drName } = this;
			const partner_role_name = this.partners.map(item => item.partner_role_name).join('、');
			const institution_name = this.team_institution_infos.map(item => item.institution_name).join('、');
			const tips1 = `团队中该商品与该达人正在合作（${status}），${drName}为[${partner_role_name}]，当前合作进度结束后才能继续合作！`;
			const tips2 = `团队中该商品与该达人正在通过团长[${institution_name}]进行合作（${status}），${drName}为[${partner_role_name}]，是否确认继续与该达人合作？
                      确认后生成达人分销类型的合作进度`;
			const tips3 = `团队中该商品与该达人未通过团长正在直接进行合作（${status}），${drName}为[${partner_role_name}]，是否确认通过团长与该达人合作？
                      确认后生成团长分销类型的合作进度`;
			const tips4 = `团队达人CRM中有商务正在跟进该达人，${drName}为[${partner_role_name}]，是否确认通过团长与该达人合作？`;
			const tips5 = `团队中该商品与该达人正在通过其他团长进行合作（${status}），${drName}为[${partner_role_name}]，是否确认通过该团长与该达人合作？
                      确认后生成团长分销类型的合作进度`;
			switch (type) {
				case 1:
					this.content = tips1;
					break;
				case 2:
					this.content = isDaren ? tips2 : tips5;
					break;
				case 3:
					this.content = tips3;
					break;
				case 4:
					this.content = tips4;
					break;
			}
		},
		handleClose() {
			this.type = 0;
			this.msg = '';
			this.partners = [];
			this.dialogVisible = false;
		},
		goToUrl() {
			if (!this.$auth.hasPermi('system:cooperationProgress-query')) {
				this.$message.warning('暂无合作进度页面权限');
				return;
			}
			const { href } = this.$router.resolve({ path: '/cooperationProgress/list' });
			window.open(href, '_blank');
		},
		submit() {
			this.handleClose();
			this.$emit('directSend');
		},
	},
	components: {
	},
};
</script>

<style lang="less" scoped>
.content {
	color: #333;
	padding: 0 8px;
	display: flex;
	.el-icon-warning {
		font-size: 16px;
		color: rgb(250, 143, 20);
	}
	.talent-wrap {
		display: flex;
		flex-wrap: wrap;
		.talent-item {
			margin-top: 12px;
			margin-right: 8px;
			width: 174px;
			height: 64px;
			border-radius: 3px;
			padding: 12px;
			background-color: rgba(36, 117, 255, 0.03);
			display: flex;
			align-items: center;
			box-sizing: border-box;
			.info {
				margin-left: 8px;
				flex: 1;
				overflow: hidden;
			}
		}
	}
}
</style>
